import { ACPSatisfactionSurveyBody } from "@/features/assessments/ACPSatisfaction";

import { useLogInTaskContext } from "../../LogInTaskContext";

export function ACPSatisfactionLoginTask() {
  const { onTaskCompleted } = useLogInTaskContext();

  return <ACPSatisfactionSurveyBody onSuccessCallback={onTaskCompleted} />;
}
